// extracted by mini-css-extract-plugin
module.exports = {"dropContainer":"FileDropModal_dropContainer__1QbN-","card":"FileDropModal_card__1NHzQ","dropdown":"FileDropModal_dropdown__Pevl4"};